import { render, staticRenderFns } from "./IPList.vue?vue&type=template&id=d50c305e"
import script from "./IPList.vue?vue&type=script&lang=js"
export * from "./IPList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports